/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';

export const CopyButtonContainer = styled.default.div`
  display: flex;
  align-items: center;
`;